import { Vector3 } from 'three'

export function subVectorArrays(
  vectorArrayA: [number, number, number],
  vectorArrayB: [number, number, number],
): [number, number, number] {
  return new Vector3()
    .fromArray(vectorArrayA)
    .sub(new Vector3().fromArray(vectorArrayB))
    .toArray()
}
